/**
 * Pure utilities for filtering overlay points by speed criteria.
 */

// A speed bound is "set" only when it is a real value. The no-filter sentinel
// for filterMin/filterMax in this app is the empty string '' (the inputs default
// to ''), so '' / null / undefined all mean "no bound" — while a numeric (or
// numeric-string) 0 is a legitimate lower bound.
function hasFilterValue(value) {
  return value !== null && value !== undefined && value !== '';
}

export function applyPointFilter(point, criteria) {
  if (!point || typeof point !== 'object') {
    return false;
  }

  const { filterMin, filterMax, bin_nos } = criteria;

  if (bin_nos && bin_nos.length > 0) {
    const speedBin = point.speed_bin;
    return speedBin !== null && speedBin !== undefined && bin_nos.includes(speedBin);
  }

  if (hasFilterValue(filterMin) && hasFilterValue(filterMax)) {
    const speed = point.shaft_speed || point.speed;
    return typeof speed === 'number' && !Number.isNaN(speed) && speed >= filterMin && speed <= filterMax;
  }

  return true;
}

export function areFilterCriteriaEqual(criteria1, criteria2) {
  if (!criteria1 || !criteria2) return false;

  return criteria1.filterMin === criteria2.filterMin &&
    criteria1.filterMax === criteria2.filterMax &&
    JSON.stringify(criteria1.bin_nos) === JSON.stringify(criteria2.bin_nos);
}

export function hasActiveFilter(criteria) {
  const { filterMin, filterMax, bin_nos } = criteria;
  return (bin_nos && bin_nos.length > 0) ||
    (hasFilterValue(filterMin) && hasFilterValue(filterMax));
}

export function mergeWithFilteredPoints(newPoints, currentPoints, filterCriteria, hasActiveFilterFlag) {
  if (!hasActiveFilterFlag) {
    return newPoints;
  }

  if (!currentPoints.length) {
    return newPoints;
  }

  const filteredOutPoints = currentPoints.filter(point =>
    !applyPointFilter(point, filterCriteria)
  );

  return [...newPoints, ...filteredOutPoints];
}

export function getSpeedFilteredOverlayPoints(selectedPoints, criteria, cache) {
  if (!selectedPoints.length) {
    return selectedPoints;
  }

  if (cache.speedFilterCache &&
    cache.lastFilterCriteria &&
    areFilterCriteriaEqual(criteria, cache.lastFilterCriteria) &&
    selectedPoints === cache.lastSelectedPointsRef) {
    return cache.speedFilterCache;
  }

  const filteredPoints = selectedPoints.filter(point => applyPointFilter(point, criteria));
  cache.speedFilterCache = filteredPoints;
  cache.lastFilterCriteria = criteria;
  cache.lastSelectedPointsRef = selectedPoints;
  return filteredPoints;
}
